// extracted by mini-css-extract-plugin
export default {"popup":"Popup--popup--0QKUS","closeBtn":"Popup--closeBtn--lBTfg"};